import type {WidgetConfig} from '../../../../form'

export const findWidgetById = (widgets: Array<WidgetConfig>, id: string) => {
  return widgets.find(({widget_id}) => (widget_id ? widget_id.includes(id) : false))
}

/**
 * Функция получения массива виджетов по доступным id
 * @param widgets - массив виджетов
 * @param allowedIds - массив widget_id, которые нужно включить или исключить
 * @param isIncluded - фильтровать включая/исключая allowedIds
 */
export const filterWidgetsById = (
  widgets: Array<WidgetConfig>,
  allowedIds: string[],
  isIncluded: boolean = true,
): Array<WidgetConfig> => {
  return widgets.filter(widget => {
    const widgetId = widget.widget_id
    if (!widgetId) {
      return false
    }

    const isMatch = allowedIds.some(allowedId => widgetId.includes(allowedId))
    return isIncluded ? isMatch : !isMatch
  })
}
